<template>
  <div id="incidentList">
    <div class="container">
      <div>
        <div class="datatable-edit__header">
          <h2>Incident List</h2>
        </div>

        <data-tables layout="table" :data="incidentListInt">
          <el-table-column v-for="items in incidentList" :prop="items.prop" :label="items.label" :key="items.prop" sortable="custom"> </el-table-column>
          <el-table-column label="More" min-width="55px">
            <template slot-scope="scope">
              <el-button type="danger" v-on:click="routeToMainIncidentPage(scope.row.IncID)">More</el-button>
            </template>
          </el-table-column>
          <el-table-column label="Cancel" min-width="55px">
            <template slot-scope="scope">
              <el-button v-if="scope.row.IncStatus !== 'Cancelled'" v-on:click="cancelClick(scope.row.IncID)">Cancel</el-button>
            </template>
          </el-table-column>
          <el-table-column label="Clone" min-width="55px">
            <template slot-scope="scope">
              <a v-on:click="cloneClick(scope.row.IncID)">Clone</a>
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import { lang } from '../locale/index'
import Cookies from 'js-cookie'
export default {
  name: 'IncidentList',
  data() {
    return {
      incidentListInt: [],
      incidentList: [
        {
          prop: 'IncChildName',
          label: 'ChildName',
        },
        {
          prop: 'IncDesc',
          label: 'Desc',
        },
        {
          prop: 'IncLocation',
          label: 'Location',
        },
        {
          prop: 'IncStatus',
          label: 'Status',
        },
        {
          prop: 'IncCorrectiveAction',
          label: 'CorrectiveAction',
        },
      ],
      incidentActionCol: {
        label: lang('More'),
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-hand-up',
            },
            handler: row => {
              window.open('http://localhost:8081/incidentForm?incID=' + row.IncID + '&mode=Appr', '_blank')
            },
            label: lang('More'),
          },
        ],
      },
    }
  },
  async mounted() {
    await this.getIncidentList()
  },
  async created() {},
  methods: {
    async getIncidentList() {
      const resp = await DataSource.shared.getIncidentList(Cookies.get('schoolSession'))
      let temp = []
      resp.Table.forEach(m => {
        if (m.IncStatus === 'Active') {
          let innerTemp = {
            IncTreatmentAction: m.IncTreatmentAction,
            IncTeacherSignature: m.IncTeacherSignature,
            IncStudentID: m.IncStudentID,
            IncStatus: 'Pending',
            IncSchoolID: m.IncSchoolID,
            IncParentNotifiedDateTime: m.IncParentNotifiedDateTime,
            IncParentNotified: m.IncParentNotified,
            IncLocation: m.IncLocation,
            IncID: m.IncID,
            IncDesc: m.IncDesc,
            IncDate_Convert: m.IncDate_Convert,
            IncDateTime_Convert: m.IncDateTime_Convert,
            IncDateTime: m.IncDateTime,
            IncChildName: m.IncChildName,
            IncCorrectiveAction: m.IncCorrectiveAction,
            IncDateTime: m.IncDateTime,
          }
          temp.push(innerTemp)
        } else {
          temp.push(m)
        }
      })
      this.incidentListInt = temp
    },
    async routeToMainIncidentPage(value) {
      window.open('http://localhost:8081/incidentForm?incID=' + value + '&mode=Appr', '_blank')
      //window.location.replace('/incidentForm?incID='+value+"&mode=Appr");
    },

    cancelClick(IncidentID) {
      this.$prompt('*Please input remark(Mandatory)', 'Cancel', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
      })
        .then(({ value }) => {
          //todo update status to cancelled.
          if (!value) {
            this.$notify.error({
              title: 'Mandatory!',
              message: 'Remark is Mandatory',
              type: 'Error',
            })
            return
          }
          const resp = DataSource.shared.cancelIncidentForm(IncidentID, value)
          resp.then(resp => {
            if (resp) {
              switch (resp.code) {
                case '88':
                  window.location.replace('/')
                  break

                case '99':
                  this.$notify.error({
                    title: 'Error',
                    message: 'Error 99',
                    type: 'Error',
                  })
                  break

                case '2':
                  this.$notify.error({
                    title: 'Failed to cancel',
                    message: 'Please contact administrator',
                    type: 'Error',
                  })
                  break

                case '8':
                  this.$notify.error({
                    title: 'Failed',
                    message: 'Invalid Status',
                    type: 'Error',
                  })

                  break

                default:
                  this.$notify({
                    title: 'Cancel',
                    message: 'Form cancelled!',
                    type: 'success',
                  })

                  setTimeout(
                    function () {
                      this.$router.go(0)
                    }.bind(this),
                    2000,
                  )
              }
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Canceled',
          })
        })
    },

    cloneClick(IncidentID) {
      this.$confirm('Confirm clone?', 'Confirmation', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
      })
        .then(({}) => {
          window.open('http://localhost:8081/incidentForm?incID=' + IncidentID + '&mode=CloneNew', '_blank')
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Canceled',
          })
        })
    },
  },
}
</script>

<style scoped></style>
